export default class ComponentFiltroAtracoes {
    constructor() {

        this.section = document.querySelector('.component-filtro_atracoes')
        this.navFilter = this.section.querySelectorAll('.navFilter ul li a')
        this.atracoes = this.section.querySelectorAll('.listagemPacotes .tipo-atracao')

        this.ready();
    }

    ready() {

        this.navFilter.forEach(el => {
            el.addEventListener('click', () => {
                const atracao = el.dataset.slug

                this.navFilter.forEach(menu => {
                    menu.classList.remove('active')
                })

                el.classList.add('active')

                if(atracao === 'todas') {
                    this.atracoes.forEach(atr => {
                        console.log(atr)
                        console.log(atr.classList)
                        atr.classList.add('active')
                    })
                } else {
                    this.atracoes.forEach(atr => {
                        console.log(atr)
                        if(!atr.classList.contains('tipo-'+atracao)) {
                            console.log(atr.classList)
                            atr.classList.remove('active')
                        } else {
                            atr.classList.add('active')
                        }
                    })
                }

            })
        })        

    }
}